interface StatusBadgeProps {
  status: 'active' | 'inactive' | 'blocked' | 'suspended';
}

const statusConfig: Record<
  StatusBadgeProps['status'],
  { label: string; className: string; dotClassName: string }
> = {
  active: {
    label: 'Ativo',
    className: 'bg-online/10 text-online',
    dotClassName: 'bg-online',
  },
  blocked: {
    label: 'Bloqueado',
    className: 'bg-error/10 text-error',
    dotClassName: 'bg-error',
  },
  suspended: {
    label: 'Suspenso',
    className: 'bg-warning/10 text-warning',
    dotClassName: 'bg-warning',
  },
  inactive: {
    label: 'Inativo',
    className: 'bg-offline/10 text-offline',
    dotClassName: 'bg-offline',
  },
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${config.className}`}
    >
      <span className={`size-1.5 rounded-full ${config.dotClassName}`} />
      {config.label}
    </span>
  );
}
